import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public isExpanded = false;
  
  constructor() { }
}
